import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export interface IPaymentHistoryDataBydate {
  payment_status: string;
  payment_date: string;
  payment_time: string;
  amount: number;
  script?: string;
}
export interface IPaymentHistoryData {
  payment_date: string;
  payment_details: IPaymentHistoryDataBydate[];
}
export interface IPaymentHistoryResponse {
  status: boolean;
  message: string;
  data: IPaymentHistoryData[];
}
export const useUserBookingsPaymentHistoryAPI = () => {
  const configuration = useConfiguration();
  const [paymentDetails, setPaymentDetails] = useState<IPaymentHistoryData[]>(null);
  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (bookingId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${BOOKING_APIS?.PAYMENT_HISTORY?.baseURL}?booking_id=${bookingId}` ?? "", {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<IPaymentHistoryResponse>) => {
            if (res.data.status === true && res.data) {
              setPaymentDetails(res.data.data);
              //
            } else {
              //
              setPaymentDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setPaymentDetails(null);
            //
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, paymentDetails };
};
